export default {
  meta: {
    title: '表单配置',
    crumbs: [{ title: '合同' }, { title: '合同设置' }]
  }
};
